import { render, staticRenderFns } from "./InputOTP.vue?vue&type=template&id=1275566e&scoped=true"
import script from "./InputOTP.vue?vue&type=script&setup=true&lang=js"
export * from "./InputOTP.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InputOTP.vue?vue&type=style&index=0&id=1275566e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1275566e",
  null
  
)

export default component.exports